import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Typography from "@mui/material/Typography";

const TONE_CONFIG = {
  positive: {
    sectionBackground: "linear-gradient(105deg, #f3fbf8, #f5fbf8)",
    iconColor: "#159457",
    iconBackground: "#dff6eb",
  },
  negative: {
    sectionBackground: "linear-gradient(105deg, #fff5f5, #fff7f7)",
    iconColor: "#d7193f",
    iconBackground: "#ffe1e5",
  },
};

const InsightSection = ({
  title,
  subtitle,
  countLabel,
  tone = "positive",
  icon: Icon,
  children,
}) => {
  const config = TONE_CONFIG[tone] || TONE_CONFIG.positive;

  return (
    <Box
      component="section"
      sx={{
        position: "relative",
        zIndex: 1,
        px: { xs: 1.875, sm: 2.625 },
        pt: { xs: 2.25, sm: 2.75 },
        pb: { xs: 2.25, sm: 2.625 },
        borderRadius: { xs: "13px", sm: "15px" },
        background: config.sectionBackground,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: { xs: "flex-start", sm: "center" },
          gap: 1.625,
          mx: "1px",
          mb: 2.125,
        }}
      >
        <Box
          sx={{
            width: 48,
            height: 44,
            display: "grid",
            placeItems: "center",
            flex: "0 0 auto",
            borderRadius: "10px",
            color: config.iconColor,
            backgroundColor: config.iconBackground,
            "& svg": {
              width: 27,
              height: 27,
              strokeWidth: 2.5,
            },
          }}
        >
          {Icon ? <Icon aria-hidden="true" /> : null}
        </Box>
        <Box sx={{ minWidth: 0 }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              flexWrap: { xs: "wrap", sm: "nowrap" },
              gap: { xs: 1, sm: 1.75 },
            }}
          >
            <Typography
              component="h2"
              sx={{
                m: 0,
                color: "#182234",
                fontSize: { xs: "23px", sm: "26px" },
                fontWeight: 600,
                letterSpacing: "-0.8px",
                lineHeight: 1.2,
              }}
            >
              {title}
            </Typography>
            <Chip
              label={countLabel}
              size="small"
              sx={{
                height: "auto",
                px: 0.375,
                py: 0.25,
                borderRadius: "99px",
                backgroundColor: "rgba(231, 233, 238, 0.78)",
                color: "#435067",
                fontSize: { xs: "12px", sm: "13px" },
                fontWeight: 500,
                "& .MuiChip-label": {
                  px: 1,
                  py: 0.5,
                },
              }}
            />
          </Box>
          <Typography
            sx={{
              mt: 0.25,
              mb: 0,
              color: "#7e8797",
              fontSize: "14px",
              lineHeight: { xs: 1.35, sm: 1.43 },
            }}
          >
            {subtitle}
          </Typography>
        </Box>
      </Box>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            sm: "repeat(2, minmax(0, 1fr))",
          },
          gap: 2.125,
          alignItems: "stretch",
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default InsightSection;
